import styled from 'styled-components'
import css from '@styled-system/css'

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.gray[6]};
  text-decoration: none;

  &:visited {
    text-decoration: none;
  }

  &:hover {
    text-decoration: underline;
    ${css({
      color: 'primary.800',
    })}
  }
`
